import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MzicSvgComponent } from '../mzic-svg/mzic-svg.component';

@Component({
  selector: 'mzic-toast',
  standalone: true,
  imports: [CommonModule, MzicSvgComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit {
  @Input() message = '';
  @Input() state: 'error' | 'success' = 'error';
  @Output() dismiss = new EventEmitter<void>();
  @ViewChild('toastContainer', { static: true }) toastContainer!: ElementRef;

  get toastClass(): string {
    return this.state === 'success' ? 'success' : 'error';
  }

  get iconPath(): string {
    return this.state === 'success'
      ? 'assets/icons/mzic-check-circle-2.svg'
      : 'assets/icons/mzic-cross-circle.svg';
  }

  get iconClass(): string {
    return this.state === 'success' ? 'neutral-700 w28' : 'white w28';
  }

  private startX = 0;
  private startY = 0;
  private threshold = 50; // minimum distance for swipe

  ngOnInit(): void {
    this.setupGestures();
  }

  private setupGestures(): void {
    const element = this.toastContainer.nativeElement;

    // Click to dismiss
    element.addEventListener('click', () => {
      this.onDismiss();
    });

    // Touch events for swipe
    element.addEventListener(
      'touchstart',
      (e: TouchEvent) => {
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
      },
      { passive: true },
    );

    element.addEventListener(
      'touchend',
      (e: TouchEvent) => {
        if (!e.changedTouches.length) return;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;

        const deltaX = endX - this.startX;
        const deltaY = endY - this.startY;

        // Check if it's a significant swipe (any direction)
        if (
          Math.abs(deltaX) > this.threshold ||
          Math.abs(deltaY) > this.threshold
        ) {
          this.onDismiss();
        }
      },
      { passive: true },
    );

    // Mouse events for desktop swipe simulation
    let isMouseDown = false;
    let startMouseX = 0;
    let startMouseY = 0;

    element.addEventListener('mousedown', (e: MouseEvent) => {
      isMouseDown = true;
      startMouseX = e.clientX;
      startMouseY = e.clientY;
    });

    element.addEventListener('mouseup', (e: MouseEvent) => {
      if (!isMouseDown) return;
      isMouseDown = false;

      const deltaX = e.clientX - startMouseX;
      const deltaY = e.clientY - startMouseY;

      // Check if it's a drag/swipe motion
      if (
        Math.abs(deltaX) > this.threshold ||
        Math.abs(deltaY) > this.threshold
      ) {
        this.onDismiss();
      }
    });

    element.addEventListener('mouseleave', () => {
      isMouseDown = false;
    });
  }

  private onDismiss(): void {
    this.dismiss.emit();
  }
}
